
// import React, { useMemo } from "react";
// import { useTabNavigation } from "../helpers/useTabNavigation";
// import DashboardStats from "../components/DashboardComponents/DashboardStats";
// import SalespersonStageDashboard from "../components/DashboardComponents/SalespersonStageDashboard";
// import FollowUpDashboard from '../components/DashboardComponents/FollowUpDashboard';
// import Departments from "./Departments";
// import { LayoutDashboard, UsersRound  } from 'lucide-react';
// // import DivisionDashboard from "../components/Dashboard/DivisionDashboard";
// import { FaSitemap } from "react-icons/fa";
// import { MdOutlineFollowTheSigns } from "react-icons/md";
// import { useSelector } from "react-redux";

// const Home = () => {
//   // Get current user data
//   // const currentUser = useMemo(() => {
//   //   const user = localStorage.getItem('user');
//   //   return user ? JSON.parse(user) : {};
//   // }, []);
//   const user = useSelector((state) => state?.user?.user);

//   // Tab configuration
//   const tabs = useMemo(() => [
//     {
//       id: 'overview',
//       label: 'Overview',
//       icon: <LayoutDashboard className="h-4 w-4" />,
//       description: 'Complete organizational overview',
//       content: (
//         <div className="space-y-6">
//           <DashboardStats viewType="all" tabId="overview" />
//           <SalespersonStageDashboard viewType="all" tabId="overview" />
//           <FollowUpDashboard viewType="all" />
//         </div>
//       )
//     },
//     {
//       id: 'my-overview',
//       label: 'My Overview',
//       icon: <UsersRound className="h-4 w-4" />,
//       description: 'Your overview',
//       content: (
//         <div className="space-y-6">
//           <DashboardStats 
//             viewType="user" 
//             userId={user._id}
//             userName={user.firstName}
//             tabId="my-overview"
//           />
//           <SalespersonStageDashboard 
//             viewType="user" 
//             userId={user._id}
//             userName={user.firstName}
//             tabId="my-overview"
//           />
//         </div>
//       )
//     },
//     // {
//     //   id: 'divisions',
//     //   label: 'Divisions',
//     //   icon: <FaBuilding className="h-4 w-4" />,
//     //   description: 'Division-wise performance analysis',
//     //   content: <DivisionDashboard />
//     // },
//     {
//       id: 'departments',
//       label: 'Departments',
//       icon: <FaSitemap className="h-4 w-4" />,
//       description: 'Department-wise performance analysis',
//       content: <Departments />
//     },
//     {
//       id: 'follow-up',
//       label: 'Folow-Up',
//       icon: <MdOutlineFollowTheSigns  className="h-4 w-4" />,
//       description: 'Follow Details analysis',
//       content: <FollowUpDashboard />
//     }
//   ], [user._id, user.firstName]);

//   const { activeTab, changeTab } = useTabNavigation(tabs);
  
//   // Find active tab data
//   const activeTabData = tabs.find(tab => tab.id === activeTab);

//   return (
//     <div className="">
//       {/* Tab Navigation with Red Background */}
//       <div className="bg-red-600 shadow-sm sticky top-0 z-10">
//         <div className="mx-auto">
//           <div className="px-4 lg:px-6">
//             <div className="flex items-center justify-between">
//               {/* Tabs */}
//               <nav className="flex space-x-2 overflow-x-auto" aria-label="Tabs">
//                 {tabs.map((tab) => {
//                   const isActive = activeTab === tab.id;
                  
//                   return (
//                     <button
//                       key={tab.id}
//                       onClick={() => changeTab(tab.id)}
//                       className={`
//                         group inline-flex items-center py-2 px-4 font-medium text-sm
//                         whitespace-nowrap transition-all duration-300 ease-in-out
//                         ${isActive
//                           ? 'bg-white text-red-600 rounded-t-lg transform -translate-y-px'
//                           : 'text-red-100 hover:text-white hover:bg-red-700 rounded-t-lg'
//                         }
//                       `}
//                       aria-current={isActive ? 'page' : undefined}
//                     >
//                       <span className="mr-2">{tab.icon}</span>
//                       <span>{tab.label}</span>
//                     </button>
//                   );
//                 })}
//               </nav>

//               {/* Active Tab Description */}
//               <div className="hidden lg:block text-sm text-red-100 ml-4 transition-all duration-300">
//                 {activeTabData?.description}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Content Area */}
//       <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6 bg-gray-50 min-h-screen">
//         {activeTabData?.content}
//       </div>
//     </div>
//   );
// };

// export default Home;


import React, { useMemo } from "react";
import { useTabNavigation } from "../../helpers/useTabNavigation";
import DashboardStats from "../../components/DashboardComponents/DashboardStats";
import SalespersonStageDashboard from "../../components/DashboardComponents/SalespersonStageDashboard";
import FollowUpDashboard from '../../components/DashboardComponents/FollowUpDashboard';
// import Departments from "../Departments";
import { LayoutDashboard, UsersRound } from 'lucide-react';
// import DivisionDashboard from "../components/Dashboard/DivisionDashboard";
// import { FaSitemap } from "react-icons/fa";
import { MdOutlineFollowTheSigns } from "react-icons/md";
import { usePermission } from "../../hooks/usePermission"; // ──── 1. usePermission இம்போர்ட் செய்கிறோம் ────

const SalesDashboard = () => {
  // ──── 2. பர்மிஷன் செக் செய்வதற்கான ஹூக் ────
  const { hasPermission, user } = usePermission();

  // Tab configuration - பர்மிஷன் அடிப்படையில் டேப்களை வடிகட்டுதல்
  const tabs = useMemo(() => {
    const allTabs = [
      {
        id: 'overview',
        label: 'Overview',
        icon: <LayoutDashboard className="h-4 w-4" />,
        description: 'Complete organizational overview',
        content: (
          <div className="space-y-6">
            <DashboardStats viewType="all" tabId="overview" />
            <SalespersonStageDashboard viewType="all" tabId="overview" />
            <FollowUpDashboard viewType="all" />
          </div>
        ),
        permissionKey: "sales:overview", // ──── 3. ஓனர் அல்லது மேலாளர்களுக்கான பர்மிஷன் கீ ────
        action: "view"
      },
      {
        id: 'my-overview',
        label: 'My Overview',
        icon: <UsersRound className="h-4 w-4" />,
        description: 'Your overview',
        content: (
          <div className="space-y-6">
            <DashboardStats 
              viewType="user" 
              userId={user?._id}
              userName={user?.firstName}
              tabId="my-overview"
            />
            <SalespersonStageDashboard 
              viewType="user" 
              userId={user?._id}
              userName={user?.firstName}
              tabId="my-overview"
            />
          </div>
        )
      },
      {
        id: 'follow-up',
        label: 'Follow-Up',
        icon: <MdOutlineFollowTheSigns className="h-4 w-4" />,
        description: 'Follow Details analysis',
        content: <FollowUpDashboard />
      }
    ];

    // ──── 4. பர்மிஷன் இல்லாத டேப்களை வடிகட்டும் லாஜிக் ────
    return allTabs.filter(tab => {
      if (!tab.permissionKey) return true; // பர்மிஷன் கீ இல்லாத டேப்களை அனைவரும் பார்க்கலாம்
      return hasPermission(tab.permissionKey, tab.action || "view");
    });
  }, [user?._id, user?.firstName, hasPermission]);

  // "my-overview" என்பதை டீஃபால்ட் ஆக்டிவ் டேப் ஆக அமைத்தல்
  const { activeTab, changeTab } = useTabNavigation(tabs, "my-overview");
  
  // ஆக்டிவ் டேப்பைக் கண்டறிதல்
  const activeTabData = tabs.find(tab => tab.id === activeTab) || tabs[0];

  return (
    <div className="">
      {/* Tab Navigation with Red Background */}
      <div className="bg-red-600 shadow-sm sticky top-0 z-20">
        <div className="mx-auto">
          <div className="px-4 lg:px-6">
            <div className="flex items-center justify-between">
              {/* Tabs */}
              <nav className="flex space-x-2 overflow-x-auto custom-scrollbar" aria-label="Tabs">
                {tabs.map((tab) => {
                  const isActive = activeTab === tab.id;
                  
                  return (
                    <button
                      key={tab.id}
                      onClick={() => changeTab(tab.id)}
                      className={`
                        group inline-flex items-center py-3 px-4 font-medium text-sm
                        whitespace-nowrap transition-all duration-300 ease-in-out
                        ${isActive
                          ? 'bg-white text-red-600 rounded-t-lg transform -translate-y-px'
                          : 'text-red-100 hover:text-white hover:bg-red-700 rounded-t-lg'
                        }
                      `}
                      aria-current={isActive ? 'page' : undefined}
                    >
                      <span className="mr-2">{tab.icon}</span>
                      <span>{tab.label}</span>
                    </button>
                  );
                })}
              </nav>

              {/* Active Tab Description */}
              <div className="hidden lg:block text-sm text-red-100 ml-4 transition-all duration-300">
                {activeTabData?.description}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="mx-auto px-4 sm:px-6 lg:px-8 py-6 bg-gray-50 min-h-screen">
        {activeTabData?.content}
      </div>
    </div>
  );
};

export default SalesDashboard;